import { useEffect } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';

declare var google: any;

const GoogleOktaSSO = () => {
  console.log('Here is ENV', process.env.OKTA_GOOGLE_ISSUER);
  useEffect(() => {
    const googleScript = document.createElement('script');
    googleScript.src = 'https://accounts.google.com/gsi/client';
    googleScript.async = true;
    googleScript.defer = true;
    document.body.appendChild(googleScript);

    const oktaScript = document.createElement('script');
    oktaScript.src = 'https://global.oktacdn.com/okta-auth-js/7.5.1/okta-auth-js.min.js';
    oktaScript.type = 'text/javascript';
    oktaScript.integrity = 'sha384-6epSwnIDkI5zFNEVNjEYy3A7aSZ+C7ehmEyG8zDJZfP9Bmnxc51TK8du+2me4pjb';
    oktaScript.crossOrigin = 'anonymous';
    document.body.appendChild(oktaScript);

    oktaScript.onload = () => {
      const oktaAuth = new OktaAuth({
        issuer: process.env.OKTA_GOOGLE_ISSUER,
        clientId: process.env.OKTA_GOOGLE_CLIENT_ID,
        redirectUri: process.env.OKTA_GOOGLE_REDIRECT_URI,
      });

      (async () => {
        const isAuthenticated = await oktaAuth.isAuthenticated();
        if (!isAuthenticated) {
          google.accounts.id.initialize({
            client_id: process.env.OKTA_GOOGLE_IDP_CLIENT_ID,
            itp_support: true,
            callback: async (_response) => {
              oktaAuth.token.getWithRedirect({
                idp: process.env.OKTA_GOOGLE_IDPS,
                scopes: ['openid', 'email', 'profile'],
                // responseType: ['token', 'id_token']
              });
            }
          });

          google.accounts.id.prompt();
        }
      })();
    };

    return () => {
      document.body.removeChild(googleScript);
      document.body.removeChild(oktaScript);
    };
  }, []);
  return null;
};

export default GoogleOktaSSO;
